/** 商标 01-45 类，与 saas_api getCategoryName 保持一致 */
export const ALL_CATEGORIES = [
  { id: 1, name: '化工原料' },
  { id: 2, name: '颜料油漆' },
  { id: 3, name: '日化用品' },
  { id: 4, name: '燃料油脂' },
  { id: 5, name: '医药用品' },
  { id: 6, name: '金属材料' },
  { id: 7, name: '机械设备' },
  { id: 8, name: '手工器械' },
  { id: 9, name: '科学仪器' },
  { id: 10, name: '医疗器械' },
  { id: 11, name: '灯具空调' },
  { id: 12, name: '运输工具' },
  { id: 13, name: '烟火相关' },
  { id: 14, name: '珠宝钟表' },
  { id: 15, name: '乐器' },
  { id: 16, name: '办公用品' },
  { id: 17, name: '橡胶制品' },
  { id: 18, name: '皮革皮具' },
  { id: 19, name: '建筑材料' },
  { id: 20, name: '家具用品' },
  { id: 21, name: '厨房洁具' },
  { id: 22, name: '绳网袋篷' },
  { id: 23, name: '纱线丝' },
  { id: 24, name: '布料床单' },
  { id: 25, name: '服装鞋帽' },
  { id: 26, name: '纽扣拉链' },
  { id: 27, name: '地毯席垫' },
  { id: 28, name: '健身器材' },
  { id: 29, name: '食品' },
  { id: 30, name: '方便食品' },
  { id: 31, name: '饲料种籽' },
  { id: 32, name: '啤酒饮料' },
  { id: 33, name: '酒精饮品' },
  { id: 34, name: '烟草烟具' },
  { id: 35, name: '广告销售' },
  { id: 36, name: '金融物管' },
  { id: 37, name: '建筑修理' },
  { id: 38, name: '通讯服务' },
  { id: 39, name: '运输贮藏' },
  { id: 40, name: '材料加工' },
  { id: 41, name: '教育娱乐' },
  { id: 42, name: '网站服务' },
  { id: 43, name: '餐饮住宿' },
  { id: 44, name: '医疗园艺' },
  { id: 45, name: '社会服务' }
]

export function formatCategoryId(id) {
  return String(id).padStart(2, '0')
}

export function getCategoryLabel(id) {
  const cat = ALL_CATEGORIES.find(item => item.id === Number(id))
  if (!cat) return ''
  return `${formatCategoryId(cat.id)} ${cat.name}`
}
